import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Chat from './components/chat/chat'
import TeamsBind from "./components/teams-bind/teams-binding";


function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/chatbot" element={<Chat />} />
                <Route path="/bind/teams" element={<TeamsBind />} />
                <Route path="/" element={<div>this is dotzero chatbot</div>} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
